import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "row row-eq-height" }
const _hoisted_7 = { class: "col-lg-4 col-sm-6 col-12" }
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = { class: "info-box" }
const _hoisted_10 = { class: "info-box mb-3" }
const _hoisted_11 = { class: "col-lg-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mt-5" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "" }, " 最新发行 ")
], -1)
const _hoisted_13 = { class: "row row-eq-height" }
const _hoisted_14 = { class: "col-lg-12" }
const _hoisted_15 = { class: "section-title mt-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", { class: "" }, " 高光 专辑 ", -1)
const _hoisted_17 = { class: "title-filter year-filter" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "filter-name" }, "年:", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "filter-element" }, "-", -1)
const _hoisted_20 = { class: "row row-eq-height" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mt-5" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "" }, " 高光 艺术家 ")
], -1)
const _hoisted_23 = { class: "row row-eq-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneresNav = _resolveComponent("GeneresNav")!
  const _component_GenreHead = _resolveComponent("GenreHead")!
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_CreateRank = _resolveComponent("CreateRank")!
  const _component_RankItem = _resolveComponent("RankItem")!
  const _component_ArticleListItem = _resolveComponent("ArticleListItem")!
  const _component_GenreInfoAlbum = _resolveComponent("GenreInfoAlbum")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_GenreInfoArtist = _resolveComponent("GenreInfoArtist")!
  const _component_GenreEdit = _resolveComponent("GenreEdit")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_wechat_title = _resolveDirective("wechat-title")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_GeneresNav),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.info)
        ? (_openBlock(), _createBlock(_component_GenreHead, {
            key: 0,
            childs: _ctx.childs,
            info: _ctx.info
          }, null, 8, ["childs", "info"]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.info.quality.index === 0)
                      ? (_openBlock(), _createBlock(_component_ElAlert, {
                          key: 0,
                          class: "mb-3",
                          title: "* 数据自动抓取，未经任何人工检查。还希望您的贡献",
                          type: "error"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" 数据质量：" + _toDisplayString(_ctx.info.quality.name) + " ", 1),
                    (_ctx.userInfo.type.index >= 2 && _ctx.info.quality.index < 2)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "ml-3 btn btn-outline-success",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showEditer && _ctx.showEditer(...args)))
                        }, "编辑"))
                      : _createCommentVNode("", true),
                    (_ctx.userInfo.type.index >= 3 && _ctx.info.quality.index == 1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: "javascript:void(0)",
                          class: "ml-3 btn btn-outline-success",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.doLockInfo && _ctx.doLockInfo(...args)))
                        }, "锁定"))
                      : _createCommentVNode("", true),
                    (_ctx.userInfo.type.index >= 4 && _ctx.info.quality.index == 2)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          href: "javascript:void(0)",
                          class: "ml-3 btn btn-outline-success",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doLockInfo && _ctx.doLockInfo(...args)))
                        }, "解锁"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(" 数据整理： "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.contribute_user, (user) => {
                      return (_openBlock(), _createBlock(_component_UserTag, {
                        key: user._id,
                        user: user,
                        full: 1
                      }, null, 8, ["user"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.userInfo.type.index >= 1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn btn-outline-primary",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlerCreateArticle && _ctx.handlerCreateArticle(...args)))
                        }, "写文章"))
                      : _createCommentVNode("", true),
                    (_ctx.userInfo.type.index >= 3)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "ml-3 btn btn-outline-primary",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlerCreateCronicles && _ctx.handlerCreateCronicles(...args)))
                        }, "编年史"))
                      : _createCommentVNode("", true),
                    (_ctx.userInfo.type.index >= 2)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: "javascript:void(0)",
                          class: "ml-3 btn btn-outline-info",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handlerShowCreateRank && _ctx.handlerShowCreateRank(...args)))
                        }, "创建榜单"))
                      : _createCommentVNode("", true),
                    (_ctx.userInfo.type.index >= 2)
                      ? (_openBlock(), _createBlock(_component_CreateRank, {
                          key: 3,
                          visible: _ctx.createRankShow,
                          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createRankShow) = $event))
                        }, null, 8, ["visible"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks, (rank) => {
                  return (_openBlock(), _createBlock(_component_RankItem, {
                    key: rank._id,
                    rank: rank,
                    class: "col-lg-4 col-sm-6 col-12"
                  }, null, 8, ["rank"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article_info) => {
                  return (_openBlock(), _createBlock(_component_ArticleListItem, {
                    key: article_info._id,
                    class: "col-md-4 col-sm-6 col-12",
                    article: article_info,
                    full: 2,
                    position: "related"
                  }, null, 8, ["article"]))
                }), 128))
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums_new, (album) => {
                  return (_openBlock(), _createBlock(_component_GenreInfoAlbum, {
                    key: album._id,
                    class: "col-lg-2 col-md-4 col-sm-6 col-12 mb-3",
                    album: album
                  }, null, 8, ["album"]))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.album_loading]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.filterAlbum.beginYear,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterAlbum.beginYear) = $event)),
                    class: "filter-element",
                    size: "small"
                  }, null, 8, ["modelValue"]),
                  _hoisted_19,
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.filterAlbum.endYear,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterAlbum.endYear) = $event)),
                    class: "filter-element",
                    size: "small"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums, (album) => {
                  return (_openBlock(), _createBlock(_component_GenreInfoAlbum, {
                    key: album._id,
                    class: "col-lg-2 col-md-4 col-sm-6 col-12 mb-3",
                    album: album
                  }, null, 8, ["album"]))
                }), 128))
              ]),
              _createVNode(_component_el_pagination, {
                layout: "prev, pager, next",
                total: _ctx.paginationAlbum.total > 240 ? 240 : _ctx.paginationAlbum.total,
                "page-size": 24,
                class: "text-center mt-3",
                onCurrentChange: _ctx.handleAlbumPageChange
              }, null, 8, ["total", "onCurrentChange"])
            ])), [
              [_directive_loading, _ctx.album_loading]
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artists, (artist) => {
                  return (_openBlock(), _createBlock(_component_GenreInfoArtist, {
                    key: artist._id,
                    class: "col-lg-2 col-md-4 col-sm-6 col-12 mb-3",
                    artist: artist
                  }, null, 8, ["artist"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.info && _ctx.info._id)
        ? (_openBlock(), _createBlock(_component_GenreEdit, {
            key: 1,
            info: _ctx.info,
            onChange: _ctx.refreshData,
            id: _ctx.info._id,
            visible: _ctx.dialogFormEditVisible,
            "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogFormEditVisible) = $event))
          }, null, 8, ["info", "onChange", "id", "visible"]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ])), [
    [_directive_wechat_title, _ctx.info? _ctx.info.name || _ctx.info.name_orig:undefined]
  ])
}